export default __webpack_public_path__ + "static/media/rocket.d836cbbf.svg";